import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AppConfigService } from '../services/app.config.service';

export interface UmsgqlUserProfile {
  email: string;
  givenName: string;
  surname: string;
  mobilePhone: string | null;
}

interface UmsgqlResponse<T> {
  data: T | null;
  errors?: Array<{ message: string }>;
}

interface GetUserProfileResponse {
  data: UmsgqlUserProfile;
}

interface UpdateUserProfileResponse {
  data: UmsgqlUserProfile;
}

@Injectable({ providedIn: 'root' })
export class UmsgqlProfileService {
  constructor(
    private httpClient: HttpClient,
    private appConfigService: AppConfigService,
  ) {}

  private get url(): string {
    return this.appConfigService.settings.umsgql.url;
  }

  getUserProfile(): Observable<UmsgqlUserProfile | null> {
    const body = {
      operationName: 'getUserProfile',
      variables: {},
      query: `query getUserProfile {
  data: userProfile {
    email
    givenName
    surname
    mobilePhone
  }
}`,
    };
    return this.httpClient
      .post<UmsgqlResponse<GetUserProfileResponse>>(this.url, body)
      .pipe(map((res) => res.data?.data ?? null));
  }

  updateUserProfile(
    email: string,
    givenName: string,
    surname: string,
    mobilePhone: string | null,
  ): Observable<UmsgqlUserProfile> {
    const body = {
      operationName: 'updateUserProfile',
      variables: { email, givenName, surname, mobilePhone },
      query: `mutation updateUserProfile($email: String, $givenName: String, $surname: String, $mobilePhone: String) {
  data: updateUserProfile(input: {email: $email, givenName: $givenName, surname: $surname, mobilePhone: $mobilePhone}) {
    email
    givenName
    surname
    mobilePhone
  }
}`,
    };
    return this.httpClient
      .post<UmsgqlResponse<UpdateUserProfileResponse>>(this.url, body)
      .pipe(map((res) => res.data!.data));
  }
}
